import React from 'react';

import * as _gv from './_gv';
import * as _hm from './_hm';
import * as _ht from './_ht';
import * as BoxC from './_ccbBoxC';
import * as IptC from './_ccbIptC';
import * as TextC from './_ccbTextC';
import * as BtnC from './_cccBtnC';
import * as LblC from './_cccLblC';
import { a } from './_cmABT';
import * as cmFTH from './_cmFTH';
import * as _cr from './_cr';
import * as _ls from './_csLcl';
import { useLdrz } from "./_csLdr";
import { useCfmz } from "./_csMdlCfm";

//import * as icv from './icv';

const $cz = {
  mb1: 2,
  mb2: 4,
  dw1: 42,
  dw2: 63,
  dw3: 84,
};

let $eml = '';
let $code = '';

export const R = (pz: {
  sPz?: _ht.dz,
  abtz?: {
    btnNextz?: _ht.dz,
    btnBackz?: _ht.dz,
    lblVclz?: _ht.dz,
  },
  cz: {
    ccd?: _ht.s,
    _20r_key?: _ht.n,
    _30r_fst?: _ht.n,
    _10rt1100i?: _ht.n
    atrCfm: (_10rz: _ht.dz) => void,
  }
}) => {

  const _sPz = _ls.usePz({
    steps: [0],
  });

  return ([

    _sPz.crt.steps[0] == 0 ?
    _cr.c(S, {
      sPz: _sPz,
      abtz: pz.abtz,
      cz: {
        _20r_key: pz.cz?._20r_key,
        _30r_fst: pz.cz?._30r_fst,
        _10rt1100i: pz.cz?._10rt1100i,
      },
    })
    : _sPz.crt.steps[0] == 1 ?
    _cr.c(C, {
      sPz: _sPz,
      abtz: pz.abtz,
      cz: {
        _20r_key: pz.cz?._20r_key,
        _30r_fst: pz.cz?._30r_fst,
        _10rt1100i: pz.cz?._10rt1100i,
        atrCfm: pz.cz?.atrCfm,
      },
    })
    : undefined

  ])
};

const S = React.memo((pz: { // send code
  sPz: _ht.dz,
  abtz?: {
    btnNextz?: _ht.dz,
    lblVclz?: _ht.dz,
  },
  cz: {
    _20r_key: _ht.n,
    _30r_fst: _ht.n,
    _10rt1100i: _ht.n,
  }
}) => {

  const _udtThis = _ls.udtThis();
//  const _gUserz = _gv.useUserz();
  const _sCfmz = useCfmz();
  const _sLdrz = useLdrz();

  const _send = async () => {
    _sLdrz.show();
    const _b2 = await _hm.ectSrlAsync([
      async () => {
        let _b = true;
        if (
          !_hm.f($eml)
        ) _b = false;
        if (!_b) {
          _sCfmz.show({
            abtz: {
              btnNextz: pz.abtz?.btnNextz,
            },
            text: `メールアドレスを入力してください`,
            ls: [
              { key: 1, text: 'はい' },
            ]
          })
        }
        return _b;
      },
    ])
    if (!_b2) {
      _sLdrz.hide();
      return;
    }
    else {
      await cmFTH.sendCodeAsync2({
//        _dmn: _gUserz.crt._dmn,
        _dmn: pz.cz._20r_key,
        _10ra1100s: $eml,
        _10rt1100i: pz.cz._10rt1100i,
      });
      _sLdrz.hide();
      $code = '';
      pz.sPz.set({
        steps: [1],
      });
    }

  }

  return (
    _cr.c(BoxC.N, {
      boxStlz: a(`dwn/${$cz.dw1} dwx/${$cz.dw2} fd/csc`),
      boxClds: [

        _cr.c(BoxC.N, {
          key: -10,
          boxStlz: a(`br/1 dw/f dwn/${$cz.dw1} dwx/${$cz.dw3} fd/css mb/${$cz.mb2} ph/${$cz.mb1} pt/${$cz.mb1} sc/lt2`),
          boxClds: [

            _cr.c(TextC.N, {
              key: -10,
              boxStlz: a(`mb/${$cz.mb1}`),
              text: '登録したメールアドレスを入力し、［送る］ ボタンを押してください。',
              textStlz: a(`tb`),
            }),

          ]
        }),

        _cr.c(LblC.N, {
          key: -30,
          abtz: pz.abtz?.lblVclz,
          boxStlz: a(`dw/${$cz.dw1} mb/${$cz.mb2}`),
          lblCz: {
            text: 'メールアドレス',
          },
          cttCz: {
            boxStlz: a(`dw/f`),
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  bEdit: true,
                  bDrt: true,
                  iptType: 't',
                  vle: $eml,
                  onChg: (_s: _ht.s) => {
                    $eml = _hm.cvtEml(_s);
                    _udtThis();
                  }
                }
              })
            ],
          }
        }),

        _cr.c(BoxC.N, {
          key: -40,
          boxStlz: a(`dwn/${$cz.dw1} fd/rac mb/${$cz.mb2}`), 
          boxClds: [

            _cr.c(BtnC.N, {
              key: -40,
/*
              abtz: {
                type: 'ctd',
                dh: 4,
              },
*/
              abtz: {
                ... pz.abtz?.btnNextz,
                dw: 'f',
                dh: 4,
              },
              lblCz: {
                text: '送る',
              },
              frmCz: {
//                boxStlz: a(`dw/42`),
                pslStlz: a(`f/1 fd/ccc`),
                pslPtyz: {
                  onPrs: _send,
                },
              },
            }),

          ]
        }),

        _cr.c(BoxC.N, {
          key: -50,
          boxStlz: a(`dwn/${$cz.dw1} dwx/${$cz.dw2} fd/css mb/${$cz.mb2}`),
          boxClds: [

            _cr.c(TextC.N, {
              key: -30,
              boxStlz: a(`mb/${$cz.mb1}`),
              text: '※ 本システムは、最新版の Safari, Chrome, Edge, FireFox にてご利用いただけます。',
              textStlz: a('ts/s'),
            }),

          ]
        })

      ]
    })
  );
});

const C = React.memo((pz: { // confirm code
  sPz: _ht.dz,
  abtz?: {
    lblVclz?: _ht.dz,
    btnNextz?: _ht.dz,
    btnBackz?: _ht.dz,
  },
  cz: {
//    ccd: _ht.s,
    _20r_key: _ht.n,
    _30r_fst: _ht.n,
    _10rt1100i: _ht.n,
    atrCfm: (_10rz: _ht.dz) => void,
  }
}) => {

  const _gUserz = _gv.useUserz();

  const _sCfmz = useCfmz();
  const _sLdrz = useLdrz();

  const _udtThis = _ls.udtThis();

  React.useEffect(() => {
    $code = '';
    _udtThis();
  }, [
    pz.sPz.crt.steps[0],
  ]);

  const _lgn = async () => {
    _sLdrz.show();
    const _b2 = await _hm.ectSrlAsync([
      async () => {
        let _b = true;
        if (
          !_hm.f($code)
        ) _b = false;
        if (!_b) {
          _sCfmz.show({
            abtz: {
              btnNextz: pz.abtz?.btnNextz,
            },
            text: `確認コードを入力してください`,
            ls: [
              { key: 1, text: 'はい' }
            ]
          })
        }
        return _b;
      },
    ])
    if (!_b2) {
      _sLdrz.hide();
      return;
    }
    const _dz = await cmFTH.cfmCodeAsync2({
//      _dmn: _gUserz.crt._dmn,
      _dmn: pz.cz._20r_key,
      _10ra1100s: $eml,
      _00ra1100s: $code,
      _10rt1100i: pz.cz?._10rt1100i,
    })
    //hf.l(`LgnMailC 132: ${hf.s(_dz)}`);
    if (_dz?.err) {
      //hf.l(`LgnMailC 134: here`);
      _sCfmz.show({
        abtz: {
          btnNextz: pz.abtz?.btnNextz,
        },
        text: '認証に失敗しました',
        ls: [
          { key: 1, text: 'はい' }
        ]
      })
      _sLdrz.hide();
    }
    else {
      //hf.l(`LgnMailC 144: here`);
/*
      await _gUserz.saveAsync({
        _10rz: _dz?._10rz,
      });
*/
      await _gUserz.saveAsync(_dz?._10z);
      //hf.l(`LgnMailC 149: here`);
      _sLdrz.hide();
      $eml = ''; $code = ''; // logout 時を考慮し初期化
//      pz.cz.atrCfm(_dz?._10rz);
      pz.cz.atrCfm(_dz?._10z);
    }
  }

  return (
    _cr.c(BoxC.N, {
      boxStlz: a(`dwn/${$cz.dw1} dwx/${$cz.dw2} fd/csc`),
      boxClds: [

        _cr.c(BoxC.N, {
          key: -10,
          boxStlz: a(`br/1 dw/f dwn/${$cz.dw1} dwx/${$cz.dw3} fd/css mb/${$cz.mb2} ph/${$cz.mb1} pt/${$cz.mb1} sc/lt2`),
          boxClds: [

            _cr.c(TextC.N, {
              key: -10,
              boxStlz: a(`mb/${$cz.mb1}`),
              text: `前画面で入力したメールアドレス「${$eml}」宛に送信された確認コードを入力してください。`,
              textStlz: a(`tb`),
            }),

          ]
        }),

        _cr.c(LblC.N, {
          key: -20,
/*
          abtz: {
            type: 'vcl'
          },
*/
          abtz: pz.abtz?.lblVclz,
          boxStlz: a(`dw/${$cz.dw1} mb/${$cz.mb2}`),
          lblCz: {
            text: '確認コード',
          },
          cttCz: {
            boxStlz: a(`dw/f`),
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  bEdit: true,
                  iptType: 't',
                  vle: $code,
                  onChg: (_s: _ht.s) => {
                    $code = _s;
                  }
                }
              })
            ],
          }
        }),

        _cr.c(BoxC.N, {
          key: -30,
          boxStlz: a(`dwn/${$cz.dw1} fd/rac mb/${$cz.mb2}`), 
          boxClds: [

            _cr.c(BtnC.N, {
              key: -10,
//              abtz: icv.abtz.btnBack,
              abtz: {
                ... pz.abtz?.btnBackz,
                dw: 20,
                dh: 4,
              },
              lblCz: {
                text: '前の画面に戻る',
              },
              frmCz: {
                pslStlz: a(`f/1 fd/ccc ph/1`),
                pslPtyz: {
                  onPrs: () => {
                    pz.sPz.set({
                      steps: [0],
                    })
                  }
                },
              }
            }),

            _cr.c(BtnC.N, {
              key: -20,
//              abtz: icv.abtz.btnNext,
              abtz: {
                ... pz.abtz?.btnNextz,
                dw: 20,
                dh: 4,
              },
              lblCz: {
                text: '送る',
              },
              frmCz: {
//                boxStlz: a('dwn/20'),
                pslStlz: a(`f/1 fd/ccc ph/1`),
                pslPtyz: {
                  onPrs: _lgn,
                },
              }
            }),

          ]
        }),

        _cr.c(BoxC.N, {
          key: -50,
          boxStlz: a(`dwn/${$cz.dw1} dwx/${$cz.dw2} fd/css`),
          boxClds: [

            _cr.c(TextC.N, {
              key: -10,
              boxStlz: a(`mb/${$cz.mb1}`),
              text: '※ 確認コードの入力はメールの受け取りから30分以内に行ってください。30分を過ぎると、新しい確認コードが必要になりますので、ご注意ください。',
              textStlz: a(`ts/s`),
            }),

            _cr.c(TextC.N, {
              key: -20,
              boxStlz: a(`mb/${$cz.mb1}`),
              text: '※ 指定したメールアドレス宛に確認コードが送信されない場合は、使用しているメールアプリや通信キャリアの受信設定もご確認ください。',
              textStlz: a(`ts/s`),
            }),

            _cr.c(TextC.N, {
              key: -30,
              boxStlz: a(`mb/${$cz.mb1}`),
              text: '※ 正しい確認コードを入力したにも関わらずログインに失敗する場合は、システムに登録されているメールアドレスもご確認ください。',
              textStlz: a(`ts/s`),
            }),

          ]
        })

      ]
    })
  );
});
